import { render } from "./VRTour.vue?vue&type=template&id=a8a290b2"
import script from "./VRTour.vue?vue&type=script&lang=js"
export * from "./VRTour.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__